/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';

@tagName('')
export default class CioDeleteButton extends Component {
  @service eventBus;

  showModal = false;
  showTooltip = false;
  tooltipContent = null;
  buttonClasses = 'fly-btn--sm';
  buttonText = null;
  typeName = null;
  verb = 'delete';
  listenToDeleteEvent = false;
  deleteEventName = null;
  onDeleteStart() {}

  init() {
    super.init(...arguments);

    assert('typeName must be specified', !isNone(this.typeName));
    assert('deleteAction must be a closure action', typeof this.deleteAction === 'function');
  }

  didInsertElement() {
    super.didInsertElement(...arguments);

    if (this.listenToDeleteEvent && this.deleteEventName) {
      this.eventBus.subscribe(this.deleteEventName, this, this.onInitiateDeleteFromEvent);
    }
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);

    if (this.listenToDeleteEvent && this.deleteEventName) {
      this.eventBus.unsubscribe(this.deleteEventName, this, this.onInitiateDeleteFromEvent);
    }
  }

  @action
  onInitiateDeleteFromEvent() {
    this.onInitiateDelete(true);
  }

  @action
  onInitiateDelete(fromDeleteEvent = false) {
    if (this.isDeleteButtonDisabled) {
      return;
    }

    this.showModalAction(fromDeleteEvent);
  }

  @computed('isDisabled')
  get isDeleteButtonDisabled() {
    return this.isDisabled;
  }

  deleteTask = task(
    {
      drop: true,
    },
    async () => {
      try {
        await this.deleteAction();
      } catch (e) {
        // Ignore promise failure
      } finally {
        this.set('showModal', false);
      }
    },
  );

  @action
  showModalAction(fromDeleteEvent = false, evt) {
    evt?.preventDefault();
    evt?.stopPropagation();
    this.set('showModal', true);
    this.onDeleteStart({ fromDeleteEvent });
  }

  @action
  closeModal() {
    if (this.deleteTask.isIdle) {
      this.set('showModal', false);
    }
  }
}
